<template>
    <div>

        <a-button @click="showModal" class="btn-outline-primary" icon="edit">
            ثبت قرارداد </a-button>


        <a-modal width="1000px" v-model="visible" title=" ویرایش مهمان" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">

                <div class="row">
                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> شماره موبایل</label>
                            <input name="phone" v-model="data.phone" disabled type="number" class="form-control">


                        </div>
                    </div>

                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> نام خانوادگی</label>
                            <input name="family" v-model="data.family" type="text" class="form-control">


                        </div>
                    </div>
                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> نام</label>
                            <input name="name" v-model="data.name" type="text" class="form-control">


                        </div>
                    </div>
                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> کد ملی</label>
                            <input name="national_code" v-model="data.national_code" type="text"
                                class="form-control">


                        </div>
                    </div>
                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> تماس گیرنده</label>
                            <input disabled="disabled"
                                :value="data.caller ? data.caller.firstname + ' ' + data.caller.lastname : ''"
                                type="text" class="form-control">

                        </div>
                    </div>

                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> تعداد همراه</label>
                            <input name="count" v-model="data.count" type="number" class="form-control">
                        </div>
                    </div>

                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> تلفن ثابت</label>
                            <input name="tel" v-model="data.tel" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> شماره شناسنامه</label>
                            <input name="certificate_id" v-model="data.certificate_id" type="text"
                                class="form-control">
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label style="margin-bottom:10px;">تاریخ تولد </label>
                            <date-picker v-model="data.birthday"></date-picker>

                        </div>
                    </div>

                    <div class="col-md-4 my-1">
                        <div class="form-group text-right">
                            <label for=""> ثبت نهایی</label>
                            <select name="is_user" v-model="data.is_user" class="form-control">
                                <option value="1"> ثبت به عنوان كاربر </option>
                                <option value="0"> درانتظار </option>

                            </select>

                        </div>
                    </div>
                    <a-divider orientation="right">کارشناسان</a-divider>

                    <div class="col-md-4">
                        <label class="sr-only" for="inline-form-input-name">
                            کارشناس فروش</label>
                        <a-select mode="single" style="width:100%" placeholder="انتخاب  کارشناس "
                            v-model="data.seller_id">
                            <a-select-option v-for="item in sellers" :key="item.user.id" :value="item.user.id">
                                {{ item . user . firstname + ' ' + item . user . lastname }}
                            </a-select-option>
                        </a-select>
                    </div>

                    <div class="col-md-4">
                        <label class="sr-only" for="inline-form-input-name">
                            کارشناس دعوت کننده</label>
                        <a-select mode="single" style="width:100%" placeholder="انتخاب  کارشناس "
                            v-model="data.inviter_id">
                            <a-select-option v-for="user in inviters" :key="user.user.id" :value="user.user.id">
                                {{ user . user . firstname + ' ' + user . user . lastname }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <div class="col-md-4">
                        <label class="sr-only" for="inline-form-input-name">
                            سخنران</label>
                        <a-select mode="single" style="width:100%" placeholder="انتخاب  سخنران "
                            v-model="data.speaker_id">
                            <a-select-option v-for="speaker in speakers" :key="speaker.user.id"
                                :value="speaker.user.id">
                                {{ speaker . user . firstname + ' ' + speaker . user . lastname }}
                            </a-select-option>
                        </a-select>
                    </div>
                    <a-divider orientation="right">پرداخت</a-divider>
                    <div class="col-md-6 my-1">
                        <div class="form-group text-right">
                            <label for=""> شیوه پرداخت</label>
                            <select name="payment_type" v-model="data.payment_type" class="form-control">
                                <option value="cart">انتقال وجه کارتی</option>
                                <option value="pos">دستگاه پوز </option>
                                <option value="cash"> نقدی </option>
                                <option value="online"> پرداخت آنلاین</option>
                            </select>

                        </div>
                    </div>
                    <div class="col-md-6 my-1">
                        <div class="form-group text-right">
                            <label for=""> مقدار پرداختی (ریال)</label>
                            <input name="amount" v-model="data.amount" type="number" class="form-control">

                        </div>
                    </div>




                    <div class="col-md-12 my-1">
                        <div class="form-group text-right">
                            <label for=""> آدرس</label>
                            <textarea name="address" v-model="data.address" class="form-control"></textarea>

                        </div>
                    </div>


                    <div class="col-md-12 my-1">
                        <div class="form-group text-right">
                            <label for=""> توضیحات</label>
                            <textarea name="description" v-model="data.description" class="form-control"></textarea>

                        </div>
                    </div>

                    <div class="mt-1">
                        <button :disabled="loading" type="submit" class="btn btn-fill btn-outline-success ">
                            ذخیره
                        </button>
                    </div>

                </div>

            </form>
        </a-modal>
    </div>
</template>
<script>
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

    export default {
        components: {
            datePicker: VuePersianDatetimePicker
        },
        props: {
            data: Object,
            seminar: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                speakers: [],
                inviters: [],
                sellers: [],
            };
        },
        methods: {
            showModal() {
                this.visible = true;
            },

            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')
            },


            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                if (this.data.birthday != undefined) {
                    data.append('birthday', this.data.birthday);
                }
                if (this.data.seller_id != undefined) {
                    data.append('seller_id', this.data.seller_id);
                }
                if (this.data.inviter_id != undefined) {
                    data.append('inviter_id', this.data.inviter_id);
                }
                if (this.data.speaker_id != undefined) {
                    data.append('speaker_id', this.data.speaker_id);
                }
                if (this.data.seminar_id != undefined) {
                    data.append('seminar_id', this.data.seminar_id);
                }
                if (this.data.phone != undefined) {
                    data.append('phone', this.data.phone);
                }
                this.loading = true;

                axios
                    .post("/seminars/guests/edit/" + this.data.id, data)
                    .then(function(response) {
                        console.log(response)
                        _this.loading = false;
                        _this.$toast.success("   کاربر با موفقیت ویرایش شد   ");
                    })
                    .catch(function(err) {
                        _this.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },


        },
        watch: {
            seminar() {
                this.speakers = this.seminar.hosts.filter(item => item.seminar_role_id == 6)
                this.inviters = this.seminar.hosts.filter(item => item.seminar_role_id == 28)
                this.sellers = this.seminar.hosts.filter(item => item.seminar_role_id == 5)
            }
        },
        mounted() {
            this.data.is_user = this.data.is_user == 1 ? 1 : 0;
        }
    };
</script>
